import React from 'react';

import classes from './WeekDayCard.module.css';
import CalendarIcon from '../../../assets/icons/icon-calendar-gray.svg';
import ClockIcon from '../../../assets/icons/icon-clock-gray.svg';
import { Link } from 'react-router-dom';
import { IsListEmpty } from '../../../utilities/CommonMethods';
import RouteEndPoints from '../../../utilities/RouteEndPoints';
import CardMenu from './CardMenu/CardMenu';
import DropdownMenuIcon from '../../../assets/icons/dropdown_menu_blue.png';
import AddIcon from '../../../assets/icons/icon-plus-blue.svg';
import DayOffIcon from '../../../assets/icons/icon-day-off.svg';
import { parseDate } from '../../../utilities/DateTimeUtils';

class WeekDayCard extends React.Component {

    state = {
        showMenuDropdown: false,
        isProgramManager: this.props.isProgramManager,
    }

    showMenuDropdown = () => {
        let status = this.state.showMenuDropdown;
        this.setState({ showMenuDropdown: !status });
    }

    markDayOffClicked = () => {
        this.setState({ showMenuDropdown: false });
        this.props.markDayOffClicked(this.props.fullDate);
    }

    createNewTopicClicked = () => {
        this.setState({ showMenuDropdown: false });
        this.props.createNewTopicClicked(this.props.weekPos, this.props.dayPos);
    }
    createNewQuizClicked = () => {
        this.setState({ showMenuDropdown: false });
        this.props.createNewQuizClicked(this.props.weekPos, this.props.dayPos);
    }
    createNewAssignmentClicked = () => {
        this.setState({ showMenuDropdown: false });
        this.props.createNewAssignmentClicked(this.props.weekPos, this.props.dayPos);
    }

    render() {

        const topicsList = !IsListEmpty(this.props.data) ? this.props.data.map((topicItem, index) => {
            let topic = '';

            if (topicItem.type === 'topic') {
                topic = (
                    <>
                        {/* ---------- Session Plan Topic Details ---------- */}
                        <Link key={index} to={this.state.isProgramManager
                            ? RouteEndPoints.PROGRAMS_PAGE + '/' + this.props.batchCode + '/modules/' + encodeURIComponent(this.props.moduleName) + '/curriculum/topic/' + topicItem.id
                            : RouteEndPoints.CURRICULUM_PAGE + '/' + this.props.batchCode + '/' + encodeURIComponent(this.props.moduleName) + '/topic/' + topicItem.id}
                            className={classes.RemoveTextDecoration}>
                            <div className={classes.TopicDataDiv}>
                                <p className={classes.TopicName}>{topicItem.name}</p>
                            </div>
                        </Link>
                    </>
                );
            } else if (topicItem.type === 'quiz') {
                topic = (
                    <>
                        {/* ---------- Quiz Topic Details ---------- */}
                        <Link key={index} to={this.state.isProgramManager
                            ? RouteEndPoints.PROGRAMS_PAGE + '/' + this.props.batchCode + '/modules/' + encodeURIComponent(this.props.moduleName) + '/curriculum/quiz/' + topicItem.id
                            : RouteEndPoints.CURRICULUM_PAGE + '/' + this.props.batchCode + '/' + encodeURIComponent(this.props.moduleName) + '/quiz/' + topicItem.id}
                            className={classes.RemoveTextDecoration}>
                            <div className={classes.QuizDataDiv}>
                                <p className={classes.TopicName}>{topicItem.name}</p>
                                <p className={classes.TopicSubmissionGradesData}>
                                    <span className={classes.TopicSpanText}>SUBMISSIONS</span>
                                    <span className={classes.TopicSpanText}>{topicItem.submissionsReceived} / {topicItem.totalStudents}</span>
                                </p>
                                <p className={classes.TopicSubmissionGradesData}>
                                    <span className={classes.TopicSpanText}>GRADES</span>
                                    <span className={classes.TopicSpanText}>{topicItem.grades} %</span>
                                </p>

                                <p className={[classes.TopicSpanText, classes.DueText].join(' ')}>DUE</p>
                                <div className={classes.IconDiv}>
                                    <img src={CalendarIcon} alt="Calender Icon" className={classes.Icon} />
                                    <span className={classes.TopicSpanText}>{topicItem.dueDate}</span>
                                </div>

                                <div className={classes.IconDiv}>
                                    <img src={ClockIcon} alt="Calender Icon" className={classes.Icon} />
                                    <span className={classes.TopicSpanText}>{topicItem.dueTime}</span>
                                </div>
                            </div>
                        </Link>
                    </>
                )
            } else if (topicItem.type === 'assignment') {
                topic = (
                    <>
                        {/* ---------- Assignment Topic Details ---------- */}
                        <Link key={index} to={this.state.isProgramManager
                            ? RouteEndPoints.PROGRAMS_PAGE + '/' + this.props.batchCode + '/modules/' + encodeURIComponent(this.props.moduleName) + '/curriculum/assignment/' + topicItem.id
                            : RouteEndPoints.CURRICULUM_PAGE + '/' + this.props.batchCode + '/' + encodeURIComponent(this.props.moduleName) + '/assignment/' + topicItem.id}
                            className={classes.RemoveTextDecoration}>
                            <div className={classes.AssignmentDataDiv}>
                                <p className={classes.TopicName}>{topicItem.name}</p>
                                <p className={classes.TopicSubmissionGradesData}>
                                    <span className={classes.TopicSpanText}>SUBMISSIONS</span>
                                    <span className={classes.TopicSpanText}>{topicItem.submissionsReceived} / {topicItem.totalStudents}</span>
                                </p>
                                <p className={classes.TopicSubmissionGradesData}>
                                    <span className={classes.TopicSpanText}>GRADES</span>
                                    <span className={classes.TopicSpanText}>{topicItem.grades} %</span>
                                </p>

                                <p className={[classes.TopicSpanText, classes.DueText].join(' ')}>DUE</p>
                                <div className={classes.IconDiv}>
                                    <img src={CalendarIcon} alt="Calender Icon" className={classes.Icon} />
                                    <span className={classes.TopicSpanText}>{topicItem.dueDate}</span>
                                </div>

                                <div className={classes.IconDiv}>
                                    <img src={ClockIcon} alt="Calender Icon" className={classes.Icon} />
                                    <span className={classes.TopicSpanText}>{topicItem.dueTime}</span>
                                </div>
                            </div>
                        </Link>
                    </>
                );
            }
            return topic

        }) : <p>No Data Available</p>;


        const today = new Date();
        const date = new Date(this.props.date + ' 2021');
        const isActive = parseDate(today) === parseDate(date) ? true : false


        return (
            <>
                {
                    this.props.moduleStart
                        ? <div className={[classes.WeekDayCard, classes.DayOffCard, isActive ? classes.Active : ''].join(' ')}>
                            {/* ----------------------- 1) Empty Gray Card----------------------- */}
                            <p className={classes.DayOffText}>Module Started</p>
                            <p className={classes.Date}>{this.props.date}</p>
                        </div>

                        : this.props.dayOff
                            ? <div className={[classes.WeekDayCard, classes.NewUnitCardContainer, isActive ? classes.Active : ''].join(' ')}>
                                <div className={classes.AddNewUnitDiv}>
                                    <div className={[classes.MenuItem, classes.IconDiv].join(' ')}>
                                        <img src={AddIcon} className={classes.NewUnitIcon} />
                                        Add New Unit
                                    </div>
                                    <p className={classes.MenuItem} onClick={this.createNewTopicClicked}>Topic</p>
                                    <p className={classes.MenuItem} onClick={this.createNewQuizClicked}>Quiz</p>
                                    <p className={classes.MenuItem} onClick={this.createNewAssignmentClicked}>Assignment</p>

                                </div>
                                {/* ----------------------- 2) Day-Off Card ----------------------- */}
                                <div className={classes.DayOffTextDiv}>
                                    <p className={classes.DayOffText}>Day Off</p>
                                </div>
                                <p className={classes.Date}>{this.props.date}</p>
                            </div>

                            : !IsListEmpty(this.props.data)
                                ? <div className={[classes.WeekDayCard, isActive ? classes.Active : ''].join(' ')} >
                                    <div className={classes.CardMenuDiv}>
                                        <div className={classes.MenuIconDiv} onClick={this.showMenuDropdown}>
                                            <img src={DropdownMenuIcon} className={classes.MenuIcon} />
                                        </div>
                                        {
                                            this.state.showMenuDropdown
                                                ? <CardMenu
                                                    show={this.state.showMenuDropdown}
                                                    markDayOffClicked={this.markDayOffClicked}
                                                    clearAllClicked={this.clearAllClicked}
                                                    createNewTopicClicked={this.createNewTopicClicked}
                                                    createNewQuizClicked={this.createNewQuizClicked}
                                                    createNewAssignmentClicked={this.createNewAssignmentClicked} />
                                                : null
                                        }
                                    </div>
                                    {/* <p className={classes.SessionText}>Session - 1</p> */}
                                    {/* ----------------------- 3) WeekDay Card ----------------------- */}
                                    {topicsList}
                                    <p className={classes.Date}>{this.props.date}</p>
                                </div>

                                :
                                <div className={[classes.WeekDayCard, classes.NewUnitCardContainer, isActive ? classes.Active : ''].join(' ')}>
                                    {/* ----------------------- 4) Add New Unit Card ----------------------- */}
                                    <div className={classes.AddNewUnitDiv}>
                                        <div className={[classes.MenuItem, classes.IconDiv].join(' ')}>
                                            <img src={AddIcon} className={classes.NewUnitIcon} />
                                            Add New Unit
                                        </div>
                                        <p className={classes.MenuItem} onClick={this.createNewTopicClicked}>Topic</p>
                                        <p className={classes.MenuItem} onClick={this.createNewQuizClicked}>Quiz</p>
                                        <p className={classes.MenuItem} onClick={this.createNewAssignmentClicked}>Assignment</p>
                                        <hr className={classes.Divider} />
                                        <div className={[classes.MenuItem, classes.IconDiv].join(' ')}
                                            onClick={this.markDayOffClicked}>
                                            <img src={DayOffIcon} className={classes.NewUnitIcon} />
                                            Mark Day Off
                                        </div>
                                    </div>
                                    <p className={classes.Date}>{this.props.date}</p>
                                </div>


                }

            </>
        );
    }
}

export default WeekDayCard;